import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import { updateAuthBackend } from "hooks/useAuthentication";
export default (payload, formValues, backendId, backendGroupSyncIsActive, serviceType, shouldUpdateGroupSync = true) => {
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const notifyOnSuccess = () => UserNotification.success(
    i18n.t("notifications.update_success", { ns: "authentication" }),
    i18n.t("notifications.success_title", { ns: "authentication" })
  );
  const notifyOnError = (error) => UserNotification.error(
    i18n.t("notifications.update_failed", { ns: "authentication", error }),
    i18n.t("notifications.error_title", { ns: "authentication" })
  );
  return updateAuthBackend(backendId, {
    ...payload,
    id: backendId
  }).then((result) => {
    if (enterpriseGroupSyncPlugin && shouldUpdateGroupSync) {
      return enterpriseGroupSyncPlugin.actions.onDirectoryServiceBackendUpdate(backendGroupSyncIsActive, formValues, backendId, serviceType).then(notifyOnSuccess).then(() => result);
    }
    notifyOnSuccess();
    return result;
  }).catch((error) => {
    notifyOnError(error);
    throw error;
  });
};
